import actionTypes from '../constants/action-types';

const settings = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SET_SETTINGS:
      return action.payload.settings;
    case actionTypes.UPDATE_SETTINGS:
      return {
        ...state,
        ...action.payload.settings,
      };
    default:
      return state;
  }
};

export default settings;
